import { formatPrice } from "@jti/format-price";
import type { MagentoPrice } from "@jti/magento-types";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./ShippingOptionLabel.module.scss";

type ShippingOptionLabelProps = {
  title: string;
  amount: MagentoPrice;
};

export const ShippingOptionLabel = ({ title, amount }: ShippingOptionLabelProps) => {
  const { __ } = useTranslations();

  const priceElement = amount?.value ? (
    <span data-testid="formattedPriceElement">{formatPrice(amount)}</span>
  ) : (
    <span data-testid="freeItemElement" className={styles.price}>
      {__("cart.shipping_options.free")}
    </span>
  );

  return (
    <div className={styles.label}>
      <span className={styles.labelText}>
        {title} - {priceElement}
      </span>
    </div>
  );
};
